import createUrlBuilder from 'utilities/url.builder.utils';
import { getRequest, postRequest } from 'utilities/service.utils';
import AppService from './app.service.context';
import { Params } from 'types';

export const fetchReferralByIdService = async (
  enquiryId: number,
  referralId: number,
  returnResponses: boolean = false,
  returnGeometry: boolean = false,
  logo: boolean = false
) => {
  const urlBuilder = createUrlBuilder(
    `/enquiries/${enquiryId}/referrals/${referralId}${
      returnResponses ? '?returnResponses=true' : ''
    }`
  );

  const params: any = {};

  params.returnGeometry = returnGeometry;

  if (logo) {
    params.include = 'LogoImageFile';
  }

  return await getRequest(AppService, urlBuilder.toString(), params);
};

export const fetchAllReferralsService = async (queryParams: Params) => {
  const {
    fields = '*',
    include = '',
    offset = 0,
    limit = 20,
    orderBy = 'name',
    filter = ''
  } = queryParams;

  const params = {
    fields,
    include,
    offset,
    limit,
    order: orderBy,
    filter
  };

  const urlBuilder = createUrlBuilder(`/enquiries/referrals`).toString();
  return await getRequest(AppService, urlBuilder, params);
};

export const fetchReferralsEmailsService = async (queryParams: Params) => {
  const {
    fields = '*',
    include = '',
    offset = 0,
    limit = 20,
    orderBy = '-createdAt',
    filter = ''
  } = queryParams;

  const params = {
    fields,
    include,
    offset,
    limit,
    order: orderBy,
    filter
  };

  const urlBuilder = createUrlBuilder(`/enquiries/referrals/emails`).toString();
  return await getRequest(AppService, urlBuilder, params);
};

export const fetchResponsesService = async (queryParams: Params) => {
  const {
    fields = '*',
    include = '',
    offset = 0,
    limit = 20,
    orderBy = '-createdAt',
    filter = ''
  } = queryParams;

  const params = {
    fields,
    include,
    offset,
    limit,
    order: orderBy,
    filter
  };

  const urlBuilder = createUrlBuilder(
    `/enquiries/referrals/responses`
  ).toString();
  return await getRequest(AppService, urlBuilder, params);
};

export const reprocessReferralsService = async (payload: any) => {
  const params = payload;
  const urlBuilder = createUrlBuilder(
    `/enquiries/referrals/reprocess`
  ).toString();

  return await postRequest(AppService, urlBuilder, params);
};
